module.exports = __webpack_public_path__ + "media/images/steps-0b1967f89c665df94555375bb3207586.png";